import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-teacher-report',
  templateUrl: './teacher-report.component.html',
  styleUrls: ['./teacher-report.component.scss']
})
export class TeacherReportComponent implements OnInit {
  teacherReportForm: FormGroup; 
  SessionNo: any;
  filteredListCourse: any;
  CourseList: any;
  collegeList: any[] = [];
  filteredCollegeList: any[] = [];
  subjectList: any;
  filteredsubjectList: any;
  userPermission: any;

  sessionList: any[];
  SessionFilterList: any[];

  constructor(public umsService: UmsService, private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService, private dialog: MatDialog,
    private dialogRef: MatDialogRef<TeacherReportComponent>) { }

  ngOnInit(): void {
    console.log("dddddddddddddd",this.data.isFinal)
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission") || '[]');
    this.teacherReportForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      CoCode: new FormControl({ value: '', disabled: true }, Validators.required),
      College: new FormControl({ value: '', disabled: true }, Validators.required),
      SubCode: new FormControl({ value: '', disabled: true }),
      Name1: new FormControl(''),
      Designation1: new FormControl(''),
      Name2: new FormControl(''),
      Designation2: new FormControl(''),
      Name3: new FormControl(''),
      Designation3: new FormControl(''),
      Name4: new FormControl(''),
      Designation4: new FormControl(''),
      Name5: new FormControl(''),
      Designation5: new FormControl(''),
      Name6: new FormControl(''),
      Designation6: new FormControl(''),
      // CoCode: new FormControl(''),
      // SubCode: new FormControl(''),
    })
     
    // if (JSON.parse(sessionStorage.getItem("session")) == null) {
    //   this.fetchSecretData();
    // }
    // else if (JSON.parse(sessionStorage.getItem("session")) != null) {
    //   let sessionData = JSON.parse(sessionStorage.getItem("session"));
    //   this.SessionNo = sessionData.SnNo
    // }
   this.fetchSession(); 
  //  this.getCourse();
    this.setupValueChanges();
  }

  // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo']
  //     }
  //   });
  // }

  setupValueChanges(): void {
  this.teacherReportForm.get('SessionId').valueChanges.subscribe((sessionId: string) => {
    if (sessionId) {
      this.teacherReportForm.get('CoCode').enable();
      this.fetchCourses();
      this.resetDependentFields(['CoCode', 'College', 'SubCode']);
    } else {
      this.teacherReportForm.get('CoCode').disable();
      this.teacherReportForm.get('College').disable();
      this.teacherReportForm.get('SubCode').disable();
      this.resetDependentFields(['CoCode', 'College', 'SubCode']);
    }
  });

  this.teacherReportForm.get('CoCode').valueChanges.subscribe((courseCode: string) => {
    if (courseCode) {
      this.teacherReportForm.get('College').enable();
      this.fetchColleges();
      this.resetDependentFields(['College', 'SubCode']);
    } else {
      this.teacherReportForm.get('College').disable();
      this.teacherReportForm.get('SubCode').disable();
      this.resetDependentFields(['College', 'SubCode']);
    }
  });

  this.teacherReportForm.get('College').valueChanges.subscribe((CgCode: any) => {
    if (CgCode !== null && CgCode !== undefined && CgCode !== '') {
      this.teacherReportForm.get('SubCode').enable();
      this.fetchSubjects(this.teacherReportForm.get('CoCode').value);
    } else {
      this.teacherReportForm.get('SubCode').disable();
      this.teacherReportForm.get('SubCode').setValue('');
      this.subjectList = [];
      this.filteredsubjectList = [];
    }
  });
}

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fetchCourses(): void {
    const sessionId = this.teacherReportForm.get('SessionId').value;
    if (!sessionId) return;

    this.spinner.show();
    const payload = { SessionID: sessionId };

    this.umsService.getSessionColgCo(payload).subscribe((res) => {
      if (res.status) {
        // Get unique courses (avoid duplicates)
        const uniqueCourses = res.data.filter((course: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.CoCgCoCode === course.CoCgCoCode)
        );
        this.CourseList = uniqueCourses;
        this.filteredListCourse = this.CourseList.slice();
        this.teacherReportForm.get('CoCode').setValue('');
      } else {
        this.CourseList = [];
        this.filteredListCourse = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching courses:', error);
      this.CourseList = [];
      this.filteredListCourse = [];
      this.spinner.hide();
    });
  }

  fetchColleges(): void {
  const courseCode = this.teacherReportForm.get('CoCode').value;
  if (!courseCode) return;

  this.spinner.show();
  const payload = { CoCode: courseCode };

  this.umsService.fetchstucourseClgMap(payload).subscribe((res) => {
    if (res.status && res.data) {
      this.collegeList = res.data;
      const userCollege = this.userPermission?.[0]?.CgUi === 'C' ? this.userPermission[0].CgId : '';
      if (userCollege) this.collegeList = this.collegeList.filter(c => c.CgCode === userCollege);
      this.filteredCollegeList = this.collegeList.slice();
      this.teacherReportForm.get('College').setValue('');
    } else {
      this.collegeList = [];
      this.filteredCollegeList = [];
    }
    this.spinner.hide();
  }, (error: HttpErrorResponse) => {
    console.error('Error fetching colleges:', error);
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.spinner.hide();
  });
}

  fetchSubjects(coCode: string): void {
    if (!coCode) return;

    this.spinner.show();
    const payload = { CoCode: coCode };
    this.umsService.getCoursewiseSub(payload).subscribe(res => {
      this.spinner.hide();
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
      this.teacherReportForm.get('SubCode').setValue('');
    }, (error) => {
      this.spinner.hide();
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  Print(): void {
  const formValue = this.teacherReportForm.value;
  const selectedSession = formValue.SessionId;
 const payload1: any = {
  EsId: formValue.SubCode,
  // SessionNo: this.SessionNo,
  SessionNo: selectedSession, 
  CourseCode: formValue.CoCode,
  CgCode: formValue.College,  
  Name1: formValue.Name1 || null,
  Name2: formValue.Name2 || null,
  Name3: formValue.Name3 || null,
  Name4: formValue.Name4 || null,
  Name5: formValue.Name5 || null,
  Name6: formValue.Name6 || null,
  Designation1: formValue.Designation1 || null,
  Designation2: formValue.Designation2 || null,
  Designation3: formValue.Designation3 || null,
  Designation4: formValue.Designation4 || null,
  Designation5: formValue.Designation5 || null,
  Designation6: formValue.Designation6 || null,
};

  console.log('Printing Exam Panel Report with payload:', payload1);
  const jsonString = JSON.stringify(payload1);
  const filter: any = {
    LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
    RptCode: 320,                                      
    InstName: '',
    InstNo: this.umsService.secretdata['ClubPartTrans'] || 0,
    ShId: '',
    CgCode: 0,
    RollNo: '',
    Cent: '',
    TnCode: '',
    EsId: 0,                                          
    CsNo: '',
    PgBreak: '',
    StrId: '',
    StrCode: '',
    RgNo: '',
    UC: '',
    Ledger: '',
    RegnRoll: '',
    DsCode: '',
    CoCode: '',                                  
    // SnNo: this.SessionNo, 
    SnNo: selectedSession,                               
    Extra1: jsonString,                                
    Mode: true      
  };

  this.umsService.setData(JSON.stringify(filter));
  this.dialog.closeAll();
  this.router.navigate(['hbsreports']);
}
 FinalPrint(): void {
  const formValue = this.teacherReportForm.value;
  const selectedSession = formValue.SessionId;
  const courseCode = formValue.CoCode;
  const collegeCode = formValue.College;
  const subjectId = formValue.SubCode;

  this.spinner.show();

  const statusPayload = {
    SessionNo: selectedSession,
    CoCode: courseCode,
    EsId: subjectId || 0,
    CgCode: collegeCode || '0'
  };

  this.umsService.getExamPanelStatusFlags(statusPayload).subscribe({
    next: (res: any) => {
      this.spinner.hide();
      if (res.status && res.data && res.data.length > 0) {
        const isFinalized = res.data[0].IsFinalized;
        const isPanelAssigned = res.data[0].IsPanelAssigned;

        if (isPanelAssigned === true && isFinalized === true) {
          this.proceedToFinalPrint(formValue, selectedSession);
        } else {
          let message = '';
          if (isPanelAssigned === true && isFinalized === false) {
            message = 'Final print is restricted until the assigned panel date. Please try again after the scheduled panel date.';
                  'Print Not Allowed';
          } else if (isPanelAssigned === false && isFinalized === false) {
            message = `Final print is restricted until the assigned panel date. Please try again on or after the scheduled panel date.`,
                  'Print Not Allowed';
          } else if (isPanelAssigned === false && isFinalized === true) {
            message = `Final print is restricted until the assigned panel date. Please try again on or after the scheduled panel date.`,
                  'Print Not Allowed';
          } else {
            message = 'Final print not allowed: Invalid status. Please contact support.';
          }
          this.showPopup(message, 'Print Not Allowed');
        }
      } else {
        this.showPopup('Unable to verify panel status. Please try again.', 'Verification Failed');
      }
    },
    error: (err) => {
      this.spinner.hide();
      console.error('Status check error:', err);
      this.showPopup('Error checking panel status. Please try again later.', 'Error');
    }
  });
}
  private proceedToFinalPrint(formValue: any, selectedSession: number): void {
    const payload1: any = {
      EsId: formValue.SubCode,
      SessionNo: selectedSession,
      CourseCode: formValue.CoCode,
      CgCode: formValue.College,
      Name1: formValue.Name1 || null,
      Name2: formValue.Name2 || null,
      Name3: formValue.Name3 || null,
      Name4: formValue.Name4 || null,
      Name5: formValue.Name5 || null,
      Name6: formValue.Name6 || null,
      Designation1: formValue.Designation1 || null,
      Designation2: formValue.Designation2 || null,
      Designation3: formValue.Designation3 || null,
      Designation4: formValue.Designation4 || null,
      Designation5: formValue.Designation5 || null,
      Designation6: formValue.Designation6 || null,
    };

    console.log('Printing Exam Panel Report with payload:', payload1);
    const jsonString = JSON.stringify(payload1);
    const filter: any = {
      LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
      RptCode: 321,                                      
      InstName: '',
      InstNo: this.umsService.secretdata['ClubPartTrans'] || 0,
      ShId: '',
      CgCode: 0,
      RollNo: '',
      Cent: '',
      TnCode: '',
      EsId: 0,                                          
      CsNo: '',
      PgBreak: '',
      StrId: '',
      StrCode: '',
      RgNo: '',
      UC: '',
      Ledger: '',
      RegnRoll: '',
      DsCode: '',
      CoCode: '',                                  
      // SnNo: this.SessionNo, 
      SnNo: selectedSession,                               
      Extra1: jsonString,                                
      Mode: true      
    };

    this.umsService.setData(JSON.stringify(filter));
    this.dialog.closeAll();
    this.router.navigate(['hbsreports']);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
  // getCourse() {
  //   this.spinner.show();
  //   const payload = {};
  //   this.umsService.getCourse(payload).subscribe(res => {
  //     if (res.status) {
  //       this.spinner.hide();
  //       this.CourseList = res.data;
  //       this.filteredListCourse = this.CourseList.slice();
  //     }
  //     else {
  //       this.spinner.hide();
  //       this.CourseList = [];
  //       this.filteredListCourse = [];
  //     }
  //   }, (ERROR: HttpErrorResponse) => {
  //     this.spinner.hide();
  //     this.CourseList = [];
  //   })
  // }

  // getsubjects(CoCode) {
  //   this.spinner.show();
  //   const payload = {};
  //   payload['CoCode'] = CoCode;
  //   this.umsService.getCoursewiseSub(payload).subscribe(res => {
  //     this.spinner.hide()
  //     this.subjectList = res.data;
  //     this.filteredsubjectList = this.subjectList.slice();
  //   });
  // }


  private resetDependentFields(fieldsToReset: string[]): void {
    fieldsToReset.forEach(field => {
      const control = this.teacherReportForm.get(field);
      if (control) {
        control.setValue('');
        if (field === 'CoCode') {
          this.CourseList = [];
          this.filteredListCourse = [];
        }
        if (field === 'College') {
          this.collegeList = [];
          this.filteredCollegeList = [];
        }
        if (field === 'SubCode') {
          this.subjectList = [];
          this.filteredsubjectList = [];
        }
      }
    });
  }
  private showPopup(message: string, title: string = 'Notification'): void {
  const data = {
    message: message,
    title: title,
    icon: 'fas fa-info-circle'   
  };
  this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
}
}